<script>
    import { getContext } from 'svelte'; const dispatch = getContext('dispatch');
    export let args = [];
</script>


<a href="#a" on:click|preventDefault|stopPropagation={() => {dispatch({dest: `glossary ${args.join(' ')}`})}}>{args.join(' ')}</a>


<style>
    a {
        color: #00a2a7;
    }
    a:hover {
        color: #13b6d1;
    }
</style>